<template>
  <div>
    <v-row
      v-if="isLoading"
      class="fill-height"
      align-content="center"
      justify="center"
    >
      <v-col class="subtitle-1 text-center" cols="12">
        Загрузка...
      </v-col>
      <v-col cols="6">
        <v-progress-linear
          color="indigo"
          indeterminate
          rounded
          height="6"
        ></v-progress-linear>
      </v-col>
    </v-row>
    <router-view v-else />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { routes } from '@/router'
import permissions from '@/common/permissions'

export default {
  created() {
    if (this.currentUser) {
      if (this.getCurrentUserHasPermission(permissions.apiStockStructure)) {
        this.actionFetchStockCategories()
      }
      if (this.getCurrentUserHasPermission(permissions.apiStockCategories)) {
        this.actionFetchStockTree()
      }
    } else {
      this.$router.push({ name: routes.dashboard })
    }
  },
  computed: {
    ...mapGetters('auth', ['currentUser', 'getCurrentUserHasPermission']),
    ...mapGetters('stock_categories', ['getStockCategoriesFetching']),
    ...mapGetters('stock_tree', ['getStockTreeFetching']),
    isLoading: function() {
      return this.getStockTreeFetching || this.getStockCategoriesFetching
    }
  },
  methods: {
    ...mapActions('stock_categories', ['actionFetchStockCategories']),
    ...mapActions('stock_tree', ['actionFetchStockTree'])
  }
}
</script>
